<template>
    <div class="visit-page">
        <page-cover
            v-if="visitPage.PageCover"
            :img="visitPage.PageCover.Image?.url ?? ''"
            :title="visitPage.PageCover.Title"
            :sub-title="visitPage.PageCover.Subtitle"
        />
        <section
            v-if="
                visitPage.PlanYourVisit &&
                visitPage.PlanYourVisit.PlanYourVisit.length > 0
            "
        >
            <div class="px-4 py-8 md:px-12 md:py-12">
                <h3
                    v-if="visitPage.PlanYourVisit.Title"
                    class="text-center text-2xl lg:text-5xl text-primary font-semibold tracking-wide"
                >
                    {{ visitPage.PlanYourVisit.Title }}
                </h3>
                <p
                    v-if="visitPage.PlanYourVisit.Subtitle"
                    class="text-center mt-4"
                >
                    {{ visitPage.PlanYourVisit.Subtitle }}
                </p>
                <div
                    class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-12 mt-8 md:mt-12"
                >
                    <visit-card
                        v-for="(visit, index) in visitPage.PlanYourVisit
                            .PlanYourVisit"
                        :key="index"
                        :title="visit.Title"
                        :image-url="visit.Image?.url ?? ''"
                        :description="visit.Description"
                        :link-url="visit.LinkUrl"
                        :link-text="visit.LinkText"
                    />
                </div>
            </div>
        </section>
        <div v-if="visitPage.OtherDetails.length > 0">
            <div v-for="(info, index) in visitPage.OtherDetails" :key="index">
                <section v-if="index % 2 === 0" class="section-bg">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                            :flip="false"
                        />
                    </div>
                </section>
                <section v-if="index % 2 === 1">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :flip="true"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                        />
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const { data: visitPage } = await useFetch(config.public.baseURl + '/visit');
useHead({
    title: 'Visit Us',
});
</script>

<style lang="scss" scoped>
.visit-page {
}
</style>
